import './Results.css';
import Product from './Product-new';
import { useState } from 'react';
import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faPrint} from '@fortawesome/free-solid-svg-icons'
import {faXmark} from '@fortawesome/free-solid-svg-icons'

function Results(props) {
    const [selected, setSelected] = useState(null);
    return (
        <div className='results modern'>
            {props.data.map(p => <Product key={p.VLX} VLX={p.VLX} Alternative={p.Alternative} ProductCode={p.ProductCode} Manufacturer={p.Manufacturer} Publicability={p.Publicability} Availability={p.Availability} IncomingAvailability={p.IncomingAvailability} MinArrivalDate={p.MinArrivalDate} MaxArrivalDate={p.MaxArrivalDate} LongDescr={p.LongDescr} ShortDescr={p.ShortDescr} schedaTecnica={p.IcecatID!==null} Image={p.Image ? p.Image : '/assets/default.jpg'} onClick={() => setSelected(p.IcecatID === null ? true : p)}/>)}
            {
                selected
                ?
                    <div className='icecat modern'>
                        {
                            selected !== true
                            ?
                                <iframe id="icecat" name="icecat" title={selected.VLX} src={`https://prf.icecat.biz/?product_id=${selected.IcecatID}&mi=start&smi=product&shopname=virtuallogic2&lang=it`}/>
                            :
                            <div className='missing'><span>Scheda Tecnica Non Disponibile</span></div>
                        }
                        <button className='closebutton' onClick={() => setSelected(null)}><FontAwesomeIcon icon={faXmark}/> Chiudi</button>
                        <button className='printButton' onClick={() => window.open(`https://prf.icecat.biz/?product_id=${selected.IcecatID}&mi=start&smi=product&shopname=virtuallogic2&lang=it`, '_blank').focus()}><FontAwesomeIcon icon={faPrint}/> Stampa</button>
                    </div>
                :
                    <></>
            }
        </div>
    );
}

export default Results;